import { useEffect, useState } from "react";
import { fetchAccountCodes } from "../Api/ViewAccountCodeMaster";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewAccountCodeMaster.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewAccountCodeMaster = () => {
  const [accountCodes, setAccountCodes] = useState([]);

  useEffect(() => {
    const loadAccountCodes = async () => {
      try {
        const data = await fetchAccountCodes();
        setAccountCodes(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Account Codes`);
      }
    };

    loadAccountCodes();
  }, []);

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="list-container">
            <h2 className="list-title">View Account Codes</h2>

            {accountCodes.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Account Code ID</th>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    <th>Account Head</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {accountCodes.map((accountCode, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{accountCode.account_Code_ID}</td>
                      <td>{accountCode.accountCode}</td>
                      <td>{accountCode.accountName}</td>
                      <td>{accountCode.accountHead}</td>
                      <td>{accountCode.status}</td>
                      <td>{moment(accountCode.createdAt).format('L')} at {moment(accountCode.createdAt).format('LTS')}</td>
                      <td>{accountCode.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No account codes found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewAccountCodeMaster;